import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const withAuthAdmin = (WrappedComponent) => {
  const AuthComponent = (props) => {
    const token = localStorage.getItem('authToken');

    if (!token) {
      // No hay token, redirigir a la página de login
      return <Navigate to="/auth/login" replace />;
    }

    try {
      const decodedToken = jwtDecode(token);
      // Asumo que el rolid está en el payload del token
      const userRoleId = decodedToken.rolId; 

      if (userRoleId === "1" || userRoleId === "3") {
        // Si el rol es 1 (admin) o 3 (soporte técnico), renderiza el componente
        return <WrappedComponent {...props} />;
      } else {
        // Si el rol no es 1 ni 3, redirigir a la página de inicio
        return <Navigate to="/home" replace />;
      }
    } catch (error) {
      console.error("Error decodificando el token:", error);
      // Si el token es inválido o ha expirado, redirigir a login
      return <Navigate to="/auth/login" replace />;
    }
  };

  return AuthComponent;
};

export default withAuthAdmin; 